<template>
  <v-dialog width="800" persistent v-model="isShow">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <div style="height: 350px">
        <v-row style="width: 95%" class="ml-5 mt-5">
          <v-col
            cols="12"
            lg="2"
            md="2"
            sm="2"
            style="padding: 0px"
            class="mr-3"
          >
            <v-text-field
              label="HostKey"
              v-model="user.hostKey"
              style="padding: 0px"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="5"
            md="5"
            sm="5"
            style="padding: 0px"
            class="mr-3"
          >
            <v-text-field
              label="Name"
              v-model="user.name"
              style="padding: 0px"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="4" style="padding: 0px">
            <v-text-field
              label="Email"
              v-model="user.email"
              style="padding: 0px"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row style="width: 95%" class="ml-5 mt-5">
          <v-col
            cols="12"
            lg="6"
            md="6"
            sm="6"
            style="padding: 0px"
            class="mr-3"
          >
            <v-text-field
              label="Department"
              v-model="user.department"
              style="padding: 0px"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="mt-2">
          <v-row style="width: 95%" class="ml-5"> AD Groups: </v-row>
          <div class="d-flex justify-start ml-5 mt-5">
            <v-chip
              v-for="(item, idx) in user.departments"
              :key="item.identity"
              class="mr-3"
              :color="getColor(idx)"
              label
              outlined
              >{{ item }}</v-chip
            >
          </div>
        </div>
        <div class="mt-5">
          <v-row style="width: 95%" class="ml-5"> Customized Groups: </v-row>
          <v-row style="width: 95%" class="ml-5">
          <v-autocomplete  style="padding: 0px" v-model="user.customizedGroup" :items="groupList" item-text="name" multiple></v-autocomplete>
          </v-row>
        </div>
        <v-row style="width: 95%" class="ml-5 mt-5">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UserEditor",
  props: { user: Object, isShow: Boolean },
  computed: {
    ...mapGetters(["groupList"]),
  },
  data: () => {
    return {
      title: "Edit",
      colors: ["red", "green", "orange", "black", "purple"],
    };
  },
  methods: {
    close() {
      this.$emit("close", "close");
    },
    getColor(idx) {
      return this.colors[idx % 5];
    },
    save() {},
  },
  mounted(){
    if (!this.groupList)
      this.$store.dispatch('getGroupList');
  },
  watch: {
    user: {
      handler() {
        if (this.user.identity) this.title = "Edit " + this.user.name;
        else this.title = "Create";
        //this.tab = 0
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>